import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

/** The rental order stores the fuel tank level as a 0–1 ratio, not as a percent. */
export const MIN_FUEL_TANK_RATIO = 0;
export const MAX_FUEL_TANK_RATIO = 1;

/**
 * @about Parses the fuel tank level, stored by the API as a 0–1 ratio in a decimal string, into
 * the number the level indicator draws. A missing, blank, unparseable or out-of-range value
 * parses to null so the caller renders its placeholder instead of a wrong level.
 */
export function parseFuelTankRatio(value: string | Nullish): number | null {
  if (isNil(value) || value.trim() === '') {
    return null;
  }

  const ratio = Number(value);

  if (!Number.isFinite(ratio) || ratio < MIN_FUEL_TANK_RATIO || ratio > MAX_FUEL_TANK_RATIO) {
    return null;
  }

  return ratio;
}
